"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DragHandle = function DragHandle() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    rx: "4"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "16",
    y1: "20",
    x2: "20",
    y2: "16",
    id: "Path-9",
    stroke: "#9E9E9E",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "10",
    y1: "20",
    x2: "20",
    y2: "10",
    id: "Path-9",
    stroke: "#9E9E9E",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "4",
    y1: "20",
    x2: "20",
    y2: "4",
    id: "Path-9",
    stroke: "#9E9E9E",
    strokeLinecap: "round"
  })))));
};

var _default = DragHandle;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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